// src/components/BoardPackConfiguration/pages/bar_chart.jsx

import React, { useState, useEffect, useRef } from 'react';
import { apiCall } from '@/api/apiCall';
import LoadingComponent from '@/components/common/LoadingComponent';
import ErrorState from '@/components/common/ErrorStateComponent';
import { safeParseFloat } from '@/lib/safeParseFloat';
import { useQueue } from '@/context/QueueContext';
import RevenueChart from '@/components/BoardPack/components/charts/RevenueChart';

const calculateMovingAverage = (data, key, period = 2) => {
  return data.map((item, index) => {
    if (index < period - 1) return { ...item, [`${key}Avg`]: null };
    let sum = 0, count = 0;
    for (let i = 0; i < period; i++) {
      const val = data[index - i][key];
       if (val != null && !isNaN(val)) {
        sum += val;
        count++;
      }
    }
    const avg = count > 0 ? Math.round(sum / count) : null;
    return { ...item, [`${key}Avg`]: isNaN(avg) ? null : avg };
  });
};

const BarChart = ({ year = "",month = "",monthNumber = "",contract = "",page = null }) => {
  const { enqueue } = useQueue();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    // if (!year || !month || !contract) return;
    // if (hasFetchedRef.current) return;
    // hasFetchedRef.current = true;
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = {
    "success": true,
    "message": "data fetched successfully",
    "data": [
        {
            "date": "01-Oct",
            "day": "WED",
            "Enforcement": "19,444",
            "Parking": "149,783"
        },
        {
            "date": "02-Oct",
            "day": "THU",
            "Enforcement": "10,539",
            "Parking": "154,711"
        },
        {
            "date": "03-Oct",
            "day": "FRI",
            "Enforcement": "15,713",
            "Parking": "154,944"
        },
        {
            "date": "04-Oct",
            "day": "SAT",
            "Enforcement": "11,444",
            "Parking": "174,409"
        },
        {
            "date": "05-Oct",
            "day": "SUN",
            "Enforcement": "14,774",
            "Parking": "156,230"
        },
        {
            "date": "06-Oct",
            "day": "MON",
            "Enforcement": "17,078",
            "Parking": "139,856"
        },
        {
            "date": "07-Oct",
            "day": "TUE",
            "Enforcement": "14,217",
            "Parking": "139,163"
        },
        {
            "date": "08-Oct",
            "day": "WED",
            "Enforcement": "13,652",
            "Parking": "148,819"
        },
        {
            "date": "09-Oct",
            "day": "THU",
            "Enforcement": "12,426",
            "Parking": "146,989"
        },
        {
            "date": "10-Oct",
            "day": "FRI",
            "Enforcement": "15,157",
            "Parking": "161,207"
        },
        {
            "date": "11-Oct",
            "day": "SAT",
            "Enforcement": "9,383",
            "Parking": "166,591"
        },
        {
            "date": "12-Oct",
            "day": "SUN",
            "Enforcement": "11,617",
            "Parking": "176,837"
        },
        {
            "date": "13-Oct",
            "day": "MON",
            "Enforcement": "14,487",
            "Parking": "145,876"
        },
        {
            "date": "14-Oct",
            "day": "TUE",
            "Enforcement": "10,461",
            "Parking": "136,973"
        },
        {
            "date": "15-Oct",
            "day": "WED",
            "Enforcement": "20,287",
            "Parking": "150,977"
        },
        {
            "date": "16-Oct",
            "day": "THU",
            "Enforcement": "15,887",
            "Parking": "160,788"
        },
        {
            "date": "17-Oct",
            "day": "FRI",
            "Enforcement": "22,174",
            "Parking": "150,296"
        },
        {
            "date": "18-Oct",
            "day": "SAT",
            "Enforcement": "13,217",
            "Parking": "159,095"
        },
        {
            "date": "19-Oct",
            "day": "SUN",
            "Enforcement": "15,061",
            "Parking": "150,127"
        },
        {
            "date": "20-Oct",
            "day": "MON",
            "Enforcement": "15,791",
            "Parking": "138,461"
        },
        {
            "date": "21-Oct",
            "day": "TUE",
            "Enforcement": "13,600",
            "Parking": "139,436"
        },
        {
            "date": "22-Oct",
            "day": "WED",
            "Enforcement": "21,835",
            "Parking": "145,919"
        },
        {
            "date": "23-Oct",
            "day": "THU",
            "Enforcement": "11,991",
            "Parking": "150,956"
        },
        {
            "date": "24-Oct",
            "day": "FRI",
            "Enforcement": "14,417",
            "Parking": "156,223"
        },
        {
            "date": "25-Oct",
            "day": "SAT",
            "Enforcement": "7,913",
            "Parking": "155,836"
        },
        {
            "date": "26-Oct",
            "day": "SUN",
            "Enforcement": "11,078",
            "Parking": "144,014"
        },
        {
            "date": "27-Oct",
            "day": "MON",
            "Enforcement": "15,504",
            "Parking": "148,191"
        },
        {
            "date": "28-Oct",
            "day": "TUE",
            "Enforcement": "13,130",
            "Parking": "136,245"
        },
        {
            "date": "29-Oct",
            "day": "WED",
            "Enforcement": "16,174",
            "Parking": "152,117"
        },
        {
            "date": "30-Oct",
            "day": "THU",
            "Enforcement": "12,000",
            "Parking": "160,751"
        },
        {
            "date": "31-Oct",
            "day": "FRI",
            "Enforcement": "12,757",
            "Parking": "164,558"
        }
    ]
}

      if (!response?.success) {
        throw new Error(response?.message || "API returned unsuccessful response");
      }

      if (response?.success && response?.data) {
        const transformed = response.data.map(item => ({
          date: item.date,
          day: item.day,
          enforcement: safeParseFloat(item.Enforcement),
          parking: safeParseFloat(item.Parking)
        }));

        const withEnfAvg = calculateMovingAverage(transformed, "enforcement");
        const finalData = calculateMovingAverage(withEnfAvg, "parking");
        setData(finalData);
      }
    } catch (err) {
      setError(err.message || "Failed to load data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} onRetry={fetchData} />;

  const Legend = (
    <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-xs md:text-sm mb-2">
      {page?.LEGEND_CONFIG?.enforcement && (
        <div className="flex items-center gap-2">
          <div className="w-10 h-3 rounded bg-[#5B9BD5]" />
          <span>{page?.LEGEND_CONFIG?.enforcement?.label}</span>
        </div>
      )}
      {page?.LEGEND_CONFIG?.parking && (
        <div className="flex items-center gap-2">
          <div className="w-10 h-3 rounded bg-[#ED7D31]" />
          <span>{page?.LEGEND_CONFIG?.parking?.label}</span>
        </div>
      )}
      {page?.LEGEND_CONFIG?.enforcementAvg && (
        <div className="flex items-center gap-2">
          <div className="w-8 h-1 relative">
            <div style={{
              position: 'absolute', top: '-1px', left: 0, width: '100%', height: '4px',
              backgroundImage: `repeating-linear-gradient(90deg, #5B9BD5 0, #5B9BD5 4px, transparent 4px, transparent 8px)`,
            }} />
          </div>
          <span>{page?.LEGEND_CONFIG?.enforcementAvg?.label}</span>
        </div>
      )}
      {page?.LEGEND_CONFIG?.parkingAvg && (
        <div className="flex items-center gap-2">
          <div className="w-8 h-1 relative">
            <div style={{
              position: 'absolute', top: '-1px', left: 0, width: '100%', height: '4px',
              backgroundImage: `repeating-linear-gradient(90deg, #ED7D31 0, #ED7D31 4px, transparent 4px, transparent 8px)`,
            }} />
          </div>
          <span>{page?.LEGEND_CONFIG?.parkingAvg?.label}</span>
        </div>
      )}
    </div>
  );

  return (
   <div>
     <RevenueChart
      title={page?.title ?? ""}
      subTitle={page?.subtitle ?? ""}
      graphTitle={page?.in_chart_content_line_1 ?? ""}
      data={data}
      loading={loading}
      error={error}
      datasetsConfig={page?.datasetsConfig}
      tableConfig={page?.tableConfig}
      customLegend={Legend}
      year={year}
      centerBaseline={true}  
    />
   </div>
  );
};

export default BarChart;